<script>
import { mapActions, mapGetters } from 'vuex';
import { CUSTOMER_TYPES, CUSTOMER_SEX_TYPES } from '@/modules/constants';
import DatePicker from '@/components/datepicker/BirthDatePicker.vue';
import { getEuropeanDate } from '@/libs/utils';

export default {
  name: 'FormInvoiceData',
  components: { DatePicker },
  data() {
    return {
      CUSTOMER_TYPES,
      CUSTOMER_SEX_TYPES,
      isMobile: true,
      formDataState: {
        customerType: '',
        firmName: '',
        firmBranch: '',
        birthDate: '',
        gender: '',
        zip: '',
        firstName: '',
        lastName: '',
        strasse: '',
        city: '',
        phone: '',
        mobile: '',
        fax: '',
        email: '',
        note: ''
      }
    };
  },
  computed: {
    ...mapGetters(['formData', 'invoiceData', 'formSubmitted', 'customer', 'branchesOptions'])
  },
  methods: {
    ...mapActions(['setInvoiceDataAction', 'updateInvoiceDataAction', 'updateFormErrorAction']),
    consoleLog: function(args) {},
    isValidEmail: function() {
      const result = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.invoiceData.email
      );
      return result;
    },
    onDateFieldClick: function() {},
    onDateSelect: function(date, name) {
      if (date.includes('/')) {
        date = getEuropeanDate(date);
      }

      this.formDataState.birthDate = date;
    }
  },
  mounted() {
    //this.formDataState = this.invoiceData ? this.invoiceData : this.formDataState;
    for (const [key, value] of Object.entries(this.invoiceData)) {
      if (value) {
        this.formDataState[key] = value;
      }
    }
  },
  updated() {
    this.setInvoiceDataAction(this.formDataState);
    this.updateFormErrorAction({ formInvoice: true });
    if (
      !(
        this.formDataState.customerType &&
        this.formDataState.gender &&
        this.formDataState.firstName &&
        this.formDataState.lastName &&
        this.formDataState.strasse &&
        this.formDataState.zip &&
        this.formDataState.phone &&
        this.formDataState.city &&
        this.formDataState.email &&
        this.isValidEmail()
      ) ||
      (this.formDataState.customerType === 'Firma' && this.formDataState.firmName === '')
    ) {
      this.updateFormErrorAction({ formInvoice: false });
    }
  }
};
</script>

<template>
  <div class="form-details-invoice-data">
    <div class="col-md-3" id="second-block">
      <div class="panel panel-default panel-hv-grey">
        <div class="panel-heading"><i class="fa fa-pencil-square-o"></i> 2. Rechnungsadresse:</div>
        <form id="vwo-hv-form-form-invoice" class="form-inputs form" @submit.prevent>
          <div class="form-step2">
            <div class="width-100">
              <div class="mb-5">
                <select
                  name="m_auftraggeber"
                  class="custom-select"
                  @change="
                    event => {
                      formDataState.customerType = event.target.value;
                      updateInvoiceDataAction({
                        customerType: formDataState.customerType
                      });
                    }
                  "
                  v-bind:class="
                    formSubmitted && !invoiceData.customerType
                      ? 'custom-select check-form2 error width-100'
                      : 'custom-select check-form2 width-100'
                  "
                >
                  <option value="" disabled selected hidden>Auftraggeber: *</option>
                  <option
                    :selected="formDataState.customerType === CUSTOMER_TYPES.PRIVATE"
                    :value="CUSTOMER_TYPES.PRIVATE"
                    >Privat</option
                  >
                  <option
                    :selected="formDataState.customerType === CUSTOMER_TYPES.COMPANY"
                    :value="CUSTOMER_TYPES.COMPANY"
                    >Firma</option
                  >
                </select>
              </div>
            </div>

            <div class="mb-5">
              <input
                v-if="
                  formDataState.customerType === CUSTOMER_TYPES.COMPANY ||
                    invoiceData.customerType === CUSTOMER_TYPES.COMPANY
                "
                @input="event => (formDataState.firmName = event.target.value)"
                @change="
                  event => {
                    formData.firmName = event.target.value;
                    updateInvoiceDataAction({
                      firmName: formDataState.firmName
                    });
                  }
                "
                v-bind:class="
                  formSubmitted && !invoiceData.firmName
                    ? 'form-control check-form2 width-100 error '
                    : 'form-control check-form2 width-100'
                "
                :value="formDataState.firmName || invoiceData.firmName"
                placeholder="*Firmenname"
                type="text"
                name="m_firmaname"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>

            <div class="mb-5">
              <select
                v-if="
                  formDataState.customerType === CUSTOMER_TYPES.COMPANY ||
                    invoiceData.customerType === CUSTOMER_TYPES.COMPANY
                "
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
                name="m_firmenbranche"
                class="custom-select check-form2 width-100"
                @change="
                  event => {
                    formDataState.firmBranch = event.target.value;
                    updateInvoiceDataAction({
                      firmBranch: formDataState.firmBranch
                    });
                  }
                "
              >
                <option value="" disabled selected hidden>Branche:</option>
                <option
                  v-for="branch in this.branchesOptions"
                  :key="branch"
                  :selected="formDataState.firmBranch === branch"
                  :value="branch"
                  >{{ branch }}</option
                >
              </select>
            </div>
          </div>
          <div class="width-100">
            <div class="mb-5">
              <select
                name="m_gender"
                class="custom-select"
                @change="
                  event => {
                    formDataState.gender = event.target.value;
                    updateInvoiceDataAction({
                      gender: formDataState.gender
                    });
                  }
                "
                v-bind:class="
                  formSubmitted && !invoiceData.gender
                    ? 'custom-select check-form2 error width-100'
                    : 'custom-select check-form2 width-100'
                "
              >
                <option value="" disabled selected hidden>Anrede: *</option>
                <option
                  :selected="formDataState.gender === CUSTOMER_SEX_TYPES.female"
                  :value="CUSTOMER_SEX_TYPES.female"
                  >Frau</option
                >
                <option :selected="formDataState.gender === CUSTOMER_SEX_TYPES.male" :value="CUSTOMER_SEX_TYPES.male"
                  >Herr</option
                >
                <option
                  :selected="formDataState.gender === CUSTOMER_SEX_TYPES.divers"
                  :value="CUSTOMER_SEX_TYPES.divers"
                  >Divers</option
                >
              </select>
            </div>
            <div class="clear"></div>
          </div>
          <div class="width-100">
            <div class="mb-5">
              <input
                v-bind:class="
                  formSubmitted && !invoiceData.firstName
                    ? 'form-control check-form2 error '
                    : 'form-control check-form2'
                "
                @input="
                  event => {
                    formDataState.firstName = event.target.value;
                    updateInvoiceDataAction({
                      firstName: formDataState.firstName
                    });
                  }
                "
                :value="formDataState.firstName || invoiceData.firstName"
                required=""
                type="text"
                class="form-control width-100"
                name="m_firstname"
                placeholder="*Vorname:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>

          <div class="width-100">
            <div class="mb-5">
              <input
                @input="
                  event => {
                    formDataState.lastName = event.target.value;
                    updateInvoiceDataAction({
                      lastName: formDataState.lastName
                    });
                  }
                "
                :value="invoiceData.lastName"
                required=""
                type="text"
                v-bind:class="
                  formSubmitted && !invoiceData.lastName
                    ? 'form-control check-form2 error width-100'
                    : 'form-control check-form2 width-100'
                "
                name="m_name"
                placeholder="*Nachname:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>

          <div class="width-100">
            <div class="mt-5">
              <input
                @input="
                  event => {
                    formDataState.strasse = event.target.value;
                    updateInvoiceDataAction({
                      strasse: formDataState.strasse
                    });
                  }
                "
                :value="formDataState.strasse || invoiceData.strasse"
                required=""
                type="text"
                class="width-100"
                v-bind:class="
                  formSubmitted && !invoiceData.strasse ? 'form-control check-form2 error ' : 'form-control check-form2'
                "
                name="m_str"
                placeholder="*Straße / Nr.:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>
          <div class="width-100">
            <div class="mt-5">
              <input
                required=""
                type="text"
                @input="
                  event => {
                    formDataState.zip = event.target.value;
                    updateInvoiceDataAction({
                      zip: formDataState.zip
                    });
                  }
                "
                :value="formDataState.zip || invoiceData.zip"
                v-bind:class="
                  formSubmitted && !invoiceData.zip ? 'form-control check-form2 error ' : 'form-control check-form2'
                "
                name="m_plz"
                class="form-control width-100"
                placeholder="*PLZ:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>
          <div class="width-100">
            <div class="mt-5">
              <input
                class="width-100"
                required=""
                type="text"
                @input="
                  event => {
                    formDataState.city = event.target.value;
                    updateInvoiceDataAction({
                      city: formDataState.city
                    });
                  }
                "
                :value="formDataState.city || invoiceData.city"
                name="m_std"
                v-bind:class="
                  formSubmitted && !invoiceData.city ? 'form-control check-form2 error ' : 'form-control check-form2'
                "
                placeholder="*Stadt:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>
          <div class="width-100">
            <div class="mt-5">
              <input
                required=""
                type="tel"
                class="width-100"
                @input="
                  event => {
                    formDataState.phone = event.target.value;
                    updateInvoiceDataAction({
                      phone: formDataState.phone
                    });
                  }
                "
                :value="formDataState.phone || invoiceData.phone"
                name="m_tel"
                v-bind:class="
                  formSubmitted && !invoiceData.phone ? 'form-control check-form2 error ' : 'form-control check-form2'
                "
                placeholder="*Telefon:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>
          <div class="width-100">
            <div class="mt-5">
              <input
                type="tel"
                @input="
                  event => {
                    formDataState.mobile = event.target.value;
                    updateInvoiceDataAction({
                      mobile: formDataState.mobile
                    });
                  }
                "
                :value="formDataState.mobile || invoiceData.mobile"
                name="m_mobile"
                class="form-control width-100"
                placeholder="Mobilnummer:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>
          <div class="width-100">
            <div class="mt-5">
              <input
                type="text"
                @input="
                  event => {
                    formDataState.fax = event.target.value;
                    updateInvoiceDataAction({
                      fax: formDataState.fax
                    });
                  }
                "
                :value="formDataState.fax || invoiceData.fax"
                name="m_fax"
                class="form-control width-100"
                placeholder="Fax:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>
          <div class="width-100">
            <div class="mt-5">
              <input
                type="email"
                class="width-100"
                @input="
                  event => {
                    formDataState.email = event.target.value;
                    updateInvoiceDataAction({
                      email: formDataState.email
                    });
                  }
                "
                :value="formDataState.email || invoiceData.email"
                name="m_mail"
                v-bind:class="
                  (formSubmitted && !invoiceData.email) || (formSubmitted && !isValidEmail())
                    ? 'form-control check-form2 error '
                    : 'form-control check-form2'
                "
                placeholder="*E-Mail:"
                :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
              />
            </div>
          </div>
          <div class="mt-5">
            <date-picker
              v-if="
                formDataState.customerType === CUSTOMER_TYPES.PRIVATE ||
                  invoiceData.customerType === CUSTOMER_TYPES.PRIVATE
              "
              input-id="m_birthdate"
              name="birthDate"
              class="form-control check-form2 width-100"
              :value="invoiceData.birthDate"
              place-holder="Geburtsdatum"
              :on-select="onDateFieldClick"
              @onDateSelected="onDateSelect"
              :disabled="customer && (customer.bsr || customer.kuchenaktuell)"
            />
          </div>
          <div class="width-100">
            <div class="mt-5">
              <textarea
                id="customer-note"
                @input="
                  event => {
                    formDataState.note = event.target.value;
                    updateInvoiceDataAction({
                      note: formDataState.note
                    });
                  }
                "
                :value="formDataState.note || invoiceData.note"
                style="height: 59px;"
                placeholder="Nachricht:"
                name="mesage"
                class="form-control middle width-100"
              ></textarea>
            </div>
          </div>
        </form>
        <div class="text-right">
          *Pflichtfeld
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import 'FormInvoiceDataStyles';
</style>
